window._define('widgets/autocompletefield', ['jquery', 'template'], function ($, template) { 'use strict';

    $.widget('OC.autocompletefield', $.ui.autocomplete, {
        elements: null,

        options: {
            forceFromList: false,
            //            source: null,
            //            dataMap: null,
            //            itemTemplate: null
        },

        // * handle source url with template
        // ie: http://www.blabhabh.org/?q=<%= term %>
        // * handle data 'option_source'
        _initSource: function () {
            var tpl,
                source = this.options.source,
                self = this;

            // TODO: in an ideal world, this component should inherit from $.ui.autocomplete AND $.OC.baseWidget
            // that's not the case currently, and we have to parse options data here
            if (!this.options.source) {
                this.options.source = this.element.data('option_source');
                source = this.options.source;
            }
            // end of ideal world comment :)

            if (typeof source === 'string' && source.match(/<%=.*%>/)) {
                tpl = template(this.options.source);

                this.source = function (request, response) {
                    var url = tpl({ term: request.term });

                    if (self.xhr) {
                        self.xhr.abort();
                    }

                    self.xhr = $.ajax({
                        url: url,
                        dataType: 'json',
                        success: function (data) {
                            response(data);
                        },
                        error: function () {
                            response([]);
                        },
                    });
                };
            } else {
                return this._super();
            }
        },

        _create: function () {
            var self = this,
                $input = this.element,
                $form = $input.closest('.form');

            this._pickedItem = null;

            this.elements = {
                $form: $form,
            };

            if (this.element.data('option_forceFromList')) {
                this.options.forceFromList = true;
            }

            $input
                .on('keydown blur', function (event) {
                    if (self.options.forceFromList) {
                        // modifying entry when an item was selected and forceFromList set to true will reset the field
                        if ((event.type === 'keydown' && self._pickedItem) || (event.type === 'blur' && !self._pickedItem)) {
                            self._resetSelected();
                        }
                    }
                })
                .on(this.widgetName + 'select', function (event, itemData) {
                    self._pickedItem = itemData;
                })
                .on(this.widgetName + 'close', function (event) {
                    if (!self._pickedItem && self.options.forceFromList) {
                        self._resetSelected();
                    }
                });

            this._super();
        },

        _resetSelected: function () {
            this.element.val('');
            this._pickedItem = null;
        },

        _search: function (value) {
            if (value.charCodeAt(0) !== 10) { // fix a strange bug in IE
                this.elements.$form.addClass('loading');
                this._super(value);
            }
        },

        __response: function (content) {
            this.elements.$form.removeClass('loading');
            this._super(content);
        },

        //        // uggly hack, we don't want (most of the time...)
        //        // the value to be shown in the input
        //        _value: function(newVal) {
        //            if (newVal) {
        //                return;
        //            }
        //            return this.valueMethod.apply( this.element, arguments );
        //        },

        // this method is called when options.mapping is set
        // dataMap: {
        //     label: 'name',
        //     value: 'slug'
        // }
        // internal data of the widget will be updated
        // with a 'value' and a 'label'
        _datamap: function (content, datamapping) {

            content = content.map(function (item) {
                if (!item.value && item[datamapping.value]) {
                    item.value = item[datamapping.value];
                }

                if (!item.label && item[datamapping.label]) {
                    item.label = item[datamapping.label];
                }

                return item;
            });

            return content;
        },

        _normalize: function (content) {
            content = this._super(content);

            if (this.options.dataMap) {
                content = this._datamap(content, this.options.dataMap);
            }

            return content;
        },

        // handle templates
        _renderItem: function (ul, item) {
            var ret;
            if (this.options.itemTemplate) {
                if (!this.itemTemplate) {
                    this.itemTemplate = template(this.options.itemTemplate);
                }

                ret = $('<li>')
                    .append(this.itemTemplate(item))
                    .appendTo(ul);

            } else {
                ret = this._super(ul, item);
            }

            return ret;
        },
    });

    return $.OC.autocompletefield;
});
